module.exports = __webpack_public_path__ + "img/ndaba-profile-min.fcc2d2f9.jpg";